import { ScrollSection } from "@/components/main-page/ScrollSection";

export function StorySection() {
  return (
    <ScrollSection id="story" title="Where we come from" compact>
      <div className="max-w-3xl space-y-6">
        <p className="text-base text-[var(--color-fg-secondary)] leading-relaxed">
          Before COSX, we built and operated technology platforms serving regulated financial services. We know what it takes to ship software where every decision is auditable, every data point is governed, and every mistake has regulatory consequences.
        </p>
        <p className="text-base text-[var(--color-fg-secondary)] leading-relaxed">
          We also saw what happened when AI arrived. The capability was extraordinary. The adoption in regulated industries was nearly zero. Not because the technology wasn't ready, but because the compliance infrastructure wasn't. Off-the-shelf AI tools couldn't meet audit requirements, couldn't guarantee data residency, couldn't keep a human in the loop in the way that regulators demand.
        </p>
        <p className="text-base text-[var(--color-fg-secondary)] leading-relaxed">
          So we built it. COSX is the platform we wished existed when we were operating in regulated environments. It started with immigration law, because that's where we saw the most immediate pain. XENI was the first agent. Robolab X for education was the second. The pattern is the same every time: take a regulated vertical, understand its compliance requirements, build an AI agent that works within them, and deploy it on a platform that handles the rest.
        </p>
      </div>
    </ScrollSection>
  );
}
